module.exports = __webpack_public_path__ + "img/a03.96721662.png";